import { render } from "./QuestionThree.vue?vue&type=template&id=53524c2b&scoped=true"
const script = {}

import "./QuestionThree.vue?vue&type=style&index=0&id=53524c2b&scoped=true&lang=scss"

import exportComponent from "/Users/silaskoehler/sublimes/bibelzentrum-herz-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53524c2b"]])

export default __exports__